module.exports = __webpack_public_path__ + "img/saidat.f5b7d407.jpeg";